import { PhasrRecommendationSideMenuController } from '../controller/PhasrRecommendationSideMenuController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { PhasrRecommendationSideMenuWebComponentSchema } from '../types';

export class PhasrRecommendationSideMenuWebComponent extends BaseWebComponentElement {
  private recommendationId: string;
  private _shouldGetDataFromBackend = false;
  private recommendationData: PhasrRecommendationSideMenuWebComponentSchema;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PhasrRecommendationSideMenuController,
    });
  }

  get shouldGetDataFromBackend(): boolean {
    return this._shouldGetDataFromBackend;
  }

  set shouldGetDataFromBackend(value: boolean) {
    this._shouldGetDataFromBackend = value;
  }

  public getRecommendationData(): PhasrRecommendationSideMenuWebComponentSchema {
    return this.recommendationData;
  }

  public setRecommendationData(data: PhasrRecommendationSideMenuWebComponentSchema) {
    this.recommendationData = data;
  }

  public setRecommendationId(recommendationId: string) {
    this.recommendationId = recommendationId;
  }

  public getRecommendationId(): string {
    return this.recommendationId;
  }
}
